import React,  { useEffect, useState } from 'react';
//import img from "../../../../../../../src/assets/LandingPizza.png";
import TextEditor from "../../../../../../Util/TextEditor/TextEditor.js";
import "./EditSports.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import { messages } from "../../../../../../messages.js";
import { config } from "../../../../../../config";
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import axiosApi from '../../../../../../core/interceptor/interceptor.js';
import backArrow from "../../../../../../assets/arrow-back.svg";

export default function EditSports() {
    const [img, setImage] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        rules: '',
        no_of_match: ''
    });
    const history = useHistory();
    const[plusIcon,setPlusIcon] = useState(<div className="add-icon">
        <FontAwesomeIcon icon={faPlus} />
    </div>);

    const userId =  useParams().id;
    const [selectedFile, setSelectedFile] = useState('');
    const [errors, setErrors] = useState({
        title: '',
        image: '',
    });
   

    const getUserDetail = () => {
        axiosApi.get(`${config.apiUrl}/sports/${userId}`)
        .then((response) => {
            let  data = response.data.data;
            setFormData({title: data.title, rules: data.rules, no_of_match: data.no_of_match});
            setImage(<img src={`${config.cdnUrl}/sports/${data.image}`} alt={data.image}/>);
            setPlusIcon('');
        })
        .catch((err) => {

        })
        .finally(() => {

        });
    }

    useEffect(() => {
      if(userId){
          getUserDetail();
      }
      //eslint-disable-next-line
    },[]);

    const handleFormChange = (event,changeRule) => {
        if(changeRule){
            setFormData((previousFormData) => ({
                ...previousFormData,
                'rules': event,
            }))
        }else{
            if(event.target.type === 'file' && event.target.files && event.target.files[0]){
                var file = event.target.files[0];
                setSelectedFile(file);
                setImage(<img src={`${URL.createObjectURL(event.target.files[0])}`} alt='' />);
                setPlusIcon('');
            }else{
                setFormData((previousFormData) => ({
                    ...previousFormData,
                    [event.target.name]: event.target.value,
                }))
            }
        }
    }

    const handleValidation = () => {
        let errorArr = {};
        let formIsValid = true;

        /***** name validation ******/
        if (!formData['title']?.trim()) {
            formIsValid = false;
            errorArr["title"] = messages && messages.emptyTitle;
        }
        if (!formData.no_of_match) {
            formIsValid = false;
            errorArr["no_of_match"] = messages && messages.emptyNoOfMatch;
        }
        if (formData.no_of_match && formData.no_of_match < 1) {
          formIsValid = false;
          errorArr["no_of_match"] = messages && messages.noOfMatchLessthanOne;
      }
        if(selectedFile === '' && !userId){
            formIsValid = false;
            errorArr["image"] = messages && messages.uploadFile;
        }
        if (selectedFile && !selectedFile.name.match(/\.(jpg|jpeg|png|gif|svg)$/)) {
            errorArr["image"] = messages && messages.notAllowedImg;
            formIsValid = false;
        }
        if (selectedFile && selectedFile.name.match(/\.(jpg|jpeg|png|gif|svg)$/) &&  selectedFile.size > 5 *1024*1024) {
            errorArr["image"] = messages && messages.imgLimit;
            formIsValid = false;
        }
        setErrors(errorArr);
        return formIsValid;
    }

    /**** Triggers when form submit *****/
    const handleSubmit = (event) => {
        event.preventDefault();
        if(handleValidation()){
            let data = new FormData();
            data.append('rules',formData.rules || '');
            data.append('title',formData.title?.trim());
            data.append('no_of_match', formData.no_of_match || '');
            if(selectedFile && selectedFile.name){
                data.append("file", selectedFile,selectedFile.name);
            }
            let apiRequest = '';
            if(userId){
                apiRequest = axiosApi.put(`${config.apiUrl}/sports/${userId}`, data)
            }else{
                 apiRequest = axiosApi.post(`${config.apiUrl}/sports`, data)
            }
            apiRequest.then((res) => {
                if (res.data.status === 'success') {
                    history.push('/admin/leagues/sports');
                }
            }, (err) => {
            })
            .catch((error) => {
            });
        }
    }

    return <>
        <div className="content-wrapper EditSports-wrapper">
            <div className="header">
                <Link to="/admin/leagues/sports"><button className="primary-btn back-btn"><img src={backArrow} alt="" />Back to Sports</button></Link>
            </div>
            <div className="inner-wrapper">
                <h2>{userId ? 'Edit a Sport' : 'Add a Sport' }</h2>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="flex-blk subject-field">
                        <label htmlFor="title">Sport Title</label>
                        <input type="text" id="title" name="title" value={formData.title} onChange={handleFormChange}/>
                        <span className="error">{errors["title"]}</span>
                    </div>
                    <div className="flex-blk subject-field">
                      <label htmlFor="no_of_match">No of games per match</label>
                      <input type="number" id="no_of_match" name="no_of_match" value={formData.no_of_match} onChange={handleFormChange}/>
                      <span className="error">{errors["no_of_match"]}</span>
                    </div>
                    <div className="flex-blk body-field">
                        <label htmlFor="rules">Rules</label>
                        <TextEditor value={formData.rules} name="rules" edit={userId ? true : false} onChange={(e) => handleFormChange(e,true)} type="sport"/>
                    </div>
                    <div className="flex-blk recipients-field">
                        <span>Image</span>
                        <p>Select image to change</p>
                        <div className="img-input">
                            <label htmlFor="img">
                                {plusIcon}
                                {img}
                                <input id="img" type="file" name="image"  onChange={handleFormChange} accept="image/*" />
                            </label>
                        </div>
                        <span className="error">{errors["image"]}</span>
                    </div>
                <button className="search-btn" type="submit">{userId ? 'Edit Sport' : 'Save Sport'}</button>
                </form>
            </div>
        </div>
    </>
}